import { merge } from "lodash-es";
import frJson from "./fr.json";
import { TEAM_FR_FR } from "#pages/team/translations/team-fr-fr";
import { delivery } from "./place/delivery";
import { USER_BONUS_TABLE_FR_FR } from "#components/tables/reports/user-bonus-table/translations";
import { TRANSACTIONAL_HISTORY_TABLE_FR_FR } from "#pages/event/event-client-detail/client-info/transactional-history/transactional-history-table/translations";
import { TRANSACTIONAL_HISTORY_FR_FR } from "#pages/event/event-client-detail/client-info/transactional-history/translations";
import { BONUS_REPORT_AT_EVENT_FR_FR } from "#pages/event/event-reports/bonus-report-at-event/translations";
import { BONUS_BY_PRODUCT_TABLE_FR_FR } from "#components/tables/reports/bonus-by-product-table/translations";
import { BONUS_BY_PRODUCT_CARDS_FR_FR } from "#components/bonus-by-product-cards/translations";
import { vendors_FR_FR } from "#pages/org/vendors/translations";
import { BONUS_CATEGORIES_FR_FR } from "#pages/place/bonus-categories/translations";
import { EXTRACT_FR_FR } from "#pages/place/extract-new/translations/extract-fr-fr";
import { BONUS_REPORT_FOR_PLACE_FR_FR } from "#pages/place/financial-reports/bonus-report-for-place/translations";
import { BONUS_REPORT_FR_FR } from "#pages/place/financial-reports/bonus-report/translations";
import { USED_BONUS_REPORT_FR_FR } from "#pages/place/financial-reports/bonus-report/used-bonus-report/translations";
import { precharge_FR_FR } from "#pages/place/precharge/pages/translations";
import { IMPORT_FR_FR } from "#pages/place/purchase-invoice/import-invoice/translations/import-fr-fr";
import { PURCHASE_INVOICE_FR_FR } from "#pages/place/purchase-invoice/translations/purchase-invoice-fr-fr";
import { backofficeFr as backoffice } from "./backoffice";
import { components } from "./components";
import { event } from "./event";
import { navFR } from "./nav";
import { noAuthFR as noAuth } from "./no-auth";
import { HAWKERS_REPORT_FR_FR } from "#pages/event/hawkers-report/translations";
import { products } from "./place/products";
import { integrations } from "./org/integrations";
import { categories } from "./org/categories";
import { emissionErrors } from "./place/emission-errors";
import vendor from "./place/settings/vendor.json";
import { placeData } from "./place/place-data";
import { TRANSACTIONS_REPORT_FR_FR } from "#components/transactions-report/translations";
import { COVERT_FR_FR } from "#pages/place/settings/couvert/translations";

const bonusByProduct = merge(
	{
		cards: BONUS_BY_PRODUCT_CARDS_FR_FR,
	},
	BONUS_BY_PRODUCT_TABLE_FR_FR,
);

const financialReport = {
	tabs: {
		bonusByProduct,
	},
};

const fr = merge(frJson, {
	components,
	backoffice,
	nav: navFR,
	place: {
		purchaseInvoiceV2: PURCHASE_INVOICE_FR_FR,
		import: IMPORT_FR_FR,
		delivery,
		emissionErrors,
		settings: {
			vendor,
			couvertEdit: COVERT_FR_FR,
		},
		extractNew: EXTRACT_FR_FR,
		bonusCategories: BONUS_CATEGORIES_FR_FR,
		usedBonusReport: USED_BONUS_REPORT_FR_FR,
		bonusReport: BONUS_REPORT_FR_FR,
		userBonusTable: USER_BONUS_TABLE_FR_FR,
		bonusReportForPlace: BONUS_REPORT_FOR_PLACE_FR_FR,
		financialReport,
		products,
		precharge: precharge_FR_FR,
		placeData,
		transactionsReport: TRANSACTIONS_REPORT_FR_FR,
	},
	event: {
		userBonusTable: USER_BONUS_TABLE_FR_FR,
		bonusReportAtEvent: BONUS_REPORT_AT_EVENT_FR_FR,
		transactionalHistory: TRANSACTIONAL_HISTORY_FR_FR,
		transactionalHistoryTable: TRANSACTIONAL_HISTORY_TABLE_FR_FR,
		financialReport,
		hawkersReport: HAWKERS_REPORT_FR_FR,
		...event,
	},
	org: {
		vendors: vendors_FR_FR,
		integrations,
		categories,
	},
	team: TEAM_FR_FR,
	noAuth,
});

export { fr };
